var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.click}},[_c('a-icon',{attrs:{"type":_vm.isFullscreen ? 'fullscreen-exit' : 'fullscreen'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }